/* istanbul ignore file */
// @todo tymofiih@wix.com research enzyme render issue

import React from 'react';
import {Button, ButtonPriority, HoverStyles} from 'wix-ui-tpa/cssVars';
import {Button as OldButton} from 'wix-ui-tpa';
import {ProvidedGlobalProps, withGlobalProps} from '../../../providers/globalPropsProvider';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import BackInStockButtonStyles from './BackInStockButton.scss';
import productPageButtonsContainerStyles from '../ProductPageButtonsContainer.scss';
import {classes as addToCartButtonClasses} from '../AddToCartButton/AddToCartButton.st.css';
import {classes as oldClasses} from '../AddToCartButton/AddToCartButtonOld.st.css';
import {classes as buyNowButtonClasses} from '../BuyNowButton/BuyNowButton.st.css';
import classNames from 'classnames';

interface BackInStockButtonInterface extends ProvidedGlobalProps, IProvidedTranslationProps {
  className?: string;
}

interface BackInStockButtonState {
  showError: boolean;
}

export enum DataHook {
  Root = 'BackInStockButton.Root',
}

class BackInStockButtonComponent extends React.Component<BackInStockButtonInterface, BackInStockButtonState> {
  private createNotification() {
    this.props.globals.handleNotifyWhenBackInStock();
  }

  private getClasses() {
    const {shouldShowWishlistButton, shouldShowAddToCartButton, shouldShowBuyNowButton} = this.props.globals;
    const shouldShowCssVarsButtonStyle = this.props.globals.experiments.addToCartButtonColorContrast;
    return classNames({
      [addToCartButtonClasses.addToCartButton]: shouldShowAddToCartButton && shouldShowCssVarsButtonStyle,
      [oldClasses.addToCartButton]: shouldShowAddToCartButton && !shouldShowCssVarsButtonStyle,
      [buyNowButtonClasses.buyNowButton]: !shouldShowAddToCartButton && shouldShowBuyNowButton,
      [productPageButtonsContainerStyles.primaryButton]: shouldShowWishlistButton,
      [this.props.className]: true,
      [BackInStockButtonStyles.fullWidth]: !shouldShowWishlistButton,
      [BackInStockButtonStyles.backInStockButton]: true,
    });
  }

  public render() {
    const shouldEnableAddToCartColorContrast = this.props.globals.experiments.addToCartButtonColorContrast;
    return shouldEnableAddToCartColorContrast ? (
      <Button
        data-hook={DataHook.Root}
        onClick={() => {
          this.createNotification();
        }}
        className={this.getClasses()}
        hoverStyle={shouldEnableAddToCartColorContrast ? HoverStyles.underline : undefined}
        priority={shouldEnableAddToCartColorContrast ? ButtonPriority.primary : undefined}>
        {this.props.t('productPage.backInStock.notifyWhenAvailable.button')}
      </Button>
    ) : (
      <OldButton
        data-hook={DataHook.Root}
        onClick={() => {
          this.createNotification();
        }}
        className={this.getClasses()}>
        {this.props.t('productPage.backInStock.notifyWhenAvailable.button')}
      </OldButton>
    );
  }
}

export const BackInStockButton = withGlobalProps(withTranslations('globals.texts')(BackInStockButtonComponent));
